export const INIT_GET_MATI_VERIFICATION = 'MATI::INIT_GET_MATI_VERIFICATION';
export const RESPONSE_GET_MATI_VERIFICATION = 'MATI::RESPONSE_GET_MATI_VERIFICATION';
export const ERROR_GET_MATI_VERIFICATION = 'MATI::ERROR_GET_MATI_VERIFICATION';
export const CLEAR_GET_MATI_VERIFICATION = 'MATI::CLEAR_GET_MATI_VERIFICATION';

export const INIT_PUT_MATI_VERIFICATION = 'MATI::INIT_PUT_MATI_VERIFICATION';
export const RESPONSE_PUT_MATI_VERIFICATION = 'MATI::RESPONSE_PUT_MATI_VERIFICATION';
export const ERROR_PUT_MATI_VERIFICATION = 'MATI::ERROR_PUT_MATI_VERIFICATION';
export const CLEAR_PUT_MATI_VERIFICATION = 'MATI::CLEAR_PUT_MATI_VERIFICATION';